import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DownloadButton } from '@/components/buttons';
import { OldDocumentsToggle } from '@/sections/documents/OldDocumentsToggle';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
export function PricingDocuments() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pricing"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== locale || $[3] !== t) {
    const files = FILES(locale);
    const oldPricings = files.oldPricings;
    let t2;
    if ($[5] !== t) {
      t2 = <Trans t={t} i18nKey="pricing.fileCurrent" />;
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = <><div className="flex flex-col items-center gap-2"><DownloadButton to={files.currentPricingDocument} testId="pricing" analyticsParam="pricing">{t2}</DownloadButton></div>{isCsLanguage && oldPricings.length > 0 && <div className="mt-4" id="oldDocuments"><OldDocumentsToggle closedTitle={t("pricing.show")} openedTitle={t("pricing.hide")} className="mx-auto justify-center" initialOpen={true}>{oldPricings.map(t3 => {
            const {
              path,
              date,
              customLabel
            } = t3;
            return <div className="mb-2 lg:mb-4" key={path}><DownloadButton to={path} testId="termsAndConditionsOld" analyticsParam="termsAndConditionsOld" variant="old" className="sm:w-full"><Trans t={t} i18nKey="pricing.oldFile">{customLabel || date}</Trans></DownloadButton></div>;
          })}</OldDocumentsToggle></div>}</>;
    $[1] = isCsLanguage;
    $[2] = locale;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}